import React from 'react';

import { useInterestSwap } from '~/hooks/useInterestSwap';

import InterestRow from '../../../InterestSwap/InterestRow';
import DateRow, { getDateRow } from '../../../Result/DateRow';
import LiveReportList from './LiveReportList';
import { ReportProps } from './types';

export default function LiveSwaps({ strategyId, from, to, setFrom, setTo }: ReportProps) {
    const { interests, totalFormatted, totalDirection, loading, onEndReached } = useInterestSwap(from, to, strategyId);

    return (
        <LiveReportList
            data={interests}
            loading={loading}
            onEndReached={onEndReached}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            totalFormatted={totalFormatted}
            totalDirection={totalDirection}
            renderDate={(item, index) =>
                getDateRow(item.timestamp, index) !== '' ? <DateRow timestamp={item.timestamp} /> : null
            }
            renderRow={(item) => <InterestRow interest={item} inStrategyView />}
        />
    );
}
